import { Box, Link, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import { Button } from 'evee-ui-common/components/base';
import { getHomeUrl } from 'evee-ui-common/utils';
import useRegion from 'store/modules/app/hooks/useRegion';

import styles from './styles';

const NovatedLeasing = ({ classes }) => {
  const { region } = useRegion();

  const source = {
    href: getHomeUrl(region) + '/pages/novated-leasing',
  };

  const titleJsx = <>Thinking about owning your own EV?</>;

  const subtitleJsx = <>You could save up to $10k/year on tax with a Novated Lease.</>;

  return (
    <Box
      display="flex"
      justifyItems="space-between"
      alignItems="center"
      className={classes.container}
    >
      <Box className={classes.titleContainer}>
        <Typography paragraph className={classes.title}>
          {titleJsx}
        </Typography>

        <Typography paragraph className={classes.subtitle}>
          {subtitleJsx}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        className={classes.iconContainer}
      >
        <Typography variant="body1" color="inherit" style={{ marginBottom: '16px' }}>
          Explore Novated Leasing
        </Typography>
        <Link href={source.href} target="_blank">
          <Button size="large" text="Get a quote" />
        </Link>
      </Box>
    </Box>
  );
};

NovatedLeasing.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    iconContainer: PropTypes.string.isRequired,
    titleContainer: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
  }).isRequired,
};

NovatedLeasing.defaultProps = {};

export default withStyles(styles)(NovatedLeasing);
